import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '@base/pages/Login'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/login',
    name: 'login',
    sectionTitle:'Login',
    loggedOut: true,
    component: LoginView
  },
  
  { path: '/profile', name:'profile', title: 'Profiel', component: () => import('@base/pages/User/Profile') },
  { path: '/profile/password', name:'profile_password', title: 'Wachtwoord', component: () => import('@base/pages/User/Password') },

  // TOOLS
  { path: '/tools', icon:'fa-gear',sectionTitle:'Tools', name:'tools_database', title: 'Database', component: () => import('@base/pages/Tools/Database') },
  { path: '/tools/mails', name:'tools_mails', title: 'Mails', component: () => import('@base/pages/Tools/Mails') },
  { path: '/tools/log', name:'tools_lot', title: 'Log', component: () => import('@base/pages/Tools/Log') },
  { path: '/tools/permissions',   name:'tools_permissions', title:"Permissions", component: () => import('@base/pages/Tools/Permissions') },
  { path: '/tools/cache', name:'tools_cache', title: 'Cache', component: () => import('@base/pages/Tools/Cache') },
  
  // SUBMISSIONS
  { path: '/submissions', sectionTitle:'Inzendingen', icon:'fa-file-circle-exclamation', title:'Overzicht',name: 'submissions_overview', component: () => import('@custom/pages/Submission/List') },

  // USE CASES
  { path: '/use-cases', sectionTitle:'Use Cases', icon:'fa-project-diagram', title:'Overzicht',name: 'use_cases_overview', component: () => import('@custom/pages/Usecase/List') },
  { path: '/use-cases/consortiums', title:'Consortiums',name: 'use_cases_consortiums', component: () => import('@custom/pages/Consortium/List') },
  { path: '/use-cases/panelmembers', title:'Panelleden',name: 'use_cases_panelmembers', component: () => import('@custom/pages/Panelmember/List') },
  { path: '/use-cases/panelmembers/:usecase_id', alias:'/use-cases/panelmembers', name: 'use_cases_panelmembers', component: () => import('@custom/pages/Panelmember/List') },
  // ORGANISATIONS
  { path: '/organisations', sectionTitle:'Organisaties', icon:'fa-building', title:'Overzicht',name: 'organisations_overview', component: () => import('@custom/pages/Organisation/List') },
  { path: '/organisations/contacts', title:'Contacten', name: 'contacts_overview', component: () => import('@custom/pages/Contact/List') },
  { path: '/organisations/contacts/:organisation_id', alias:'/organisations/contacts', name: 'contacts_overview', component: () => import('@custom/pages/Contact/List') },
  { path: '/organisations/prospects', title:'Prospects', name: 'prospects_overview', component: () => import('@custom/pages/Prospect/List') },
  
  
  // MEDEWERKERS
{ path: '/users', sectionTitle:'Gebruikers', icon:'fa-person-chalkboard', title:'Overzicht',name: 'users_overview', component: () => import('@base/pages/User/List') },
// { path: '/users/edit/:id', name: 'user_edit', component: () => import('@base/pages/User/Edit') },
// { path: '/users/new', name: 'user_add', component: () => import('@base/pages/User/Edit') },
{ path: '/users/details/:id', name: 'users_details', component: () => import('@base/pages/_Entity/Details'), meta:{title:'Gebruiker details', controller:'users'} },
{ path: '/users/edit/:id', name: 'users_edit', component: () => import('@base/pages/_Entity/Edit'), meta:{title:'Gebruiker bewerken', controller:'users', afterSave:{all:'/users'}} },
{ path: '/users/new',  name: 'users_add', component: () => import('@base/pages/_Entity/Edit'), meta:{title:'Gebruiker toevoegen', controller:'users', afterSave:{all:'/users'}} },

// roles
{ path: '/users/roles', sectionTitle:'Rollen', title:'Rollen', name: 'roles_overview', component: () => import('@base/pages/Role/List') },
{ path: '/roles/edit/:id', name: 'roles_edit', component: () => import('@base/pages/Role/Edit') },
{ path: '/roles/new', title:'Toevoegen', name: 'roles_add', component: () => import('@base/pages/Role/Edit') },

  
// SETTINGS
{ path: '/settings', sectionTitle: 'Instellingen', icon:'fa-gears', name:'settings', title:"Variabelen", component: () => import('@base/pages/Settings/Overview') },
{ path: '/settings/expertises', name:'settings_expertise', title:"Expertises", component: () => import('@custom/pages/Expertise/List')},
{ path: '/settings/mailstatus', name:'settings_mailstatus', title:"Mail status", component: () => import('@base/pages/Settings/Mailstatus') },
{ path: '/settings/mailtemplates', name:'settings_mailtemplates', title:"Mail templates", component: () => import('@base/pages/Settings/Mailtemplates') },
{ path: '/settings/msgraph', name:'settings_msgraph', title:"Microsoft", component: () => import('@base/pages/Settings/MSGraph') },


 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_COMPANY_NAME;
  next();
});

export default router
